module.exports = __webpack_public_path__ + "static/media/dice-3.a77d5c5a.svg";